export default {
      id: "oc-zstack-usage",
      viewBox: "0 0 1170 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-zstack",
      toString: function () {
        return this.url;
      }
    }